var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserTag(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_275_1008",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_275_1008)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4635 1.75026C7.26221 1.77826 4.66667 4.38459 4.66667 7.58359C4.66667 10.7826 7.26279 13.3889 10.4635 13.4169H10.484H10.5159H10.5365C13.7378 13.3889 16.3333 10.7826 16.3333 7.58359C16.3333 4.38459 13.7378 1.77826 10.5365 1.75026C10.5248 1.75026 10.5122 1.75084 10.5 1.75026C10.4872 1.75026 10.4758 1.74968 10.4635 1.75026ZM21.8647 14.0003C21.4529 14.0003 21.0655 14.1603 20.7744 14.4514L14.4512 20.7758C13.8498 21.3772 13.8498 22.3551 14.4512 22.9565L17.8771 26.3824C18.1682 26.6735 18.5556 26.8336 18.9674 26.8336C19.3793 26.8336 19.7667 26.6735 20.0578 26.3824L26.3822 20.058C26.6732 19.767 26.8333 19.379 26.8333 18.9677V15.2C26.8333 14.5385 26.2951 14.0003 25.6336 14.0003H21.8647ZM3.92155 15.7503C2.72455 15.7503 1.75 16.7912 1.75 18.0711V18.9586C1.75 20.8725 2.73898 22.5358 4.53564 23.6412C6.04706 24.5716 8.06166 25.0836 10.2083 25.0836C11.6562 25.0836 13.0402 24.8455 14.2541 24.408L13.6263 23.7802C13.1147 23.2698 12.8333 22.5901 12.8333 21.8661C12.8333 21.1422 13.1147 20.4619 13.6263 19.9509L17.533 16.0453C17.2233 15.8633 16.8725 15.7503 16.4951 15.7503H3.92155ZM23.625 16.3336C24.108 16.3336 24.5 16.725 24.5 17.2086C24.5 17.6916 24.108 18.0836 23.625 18.0836C23.142 18.0836 22.75 17.6916 22.75 17.2086C22.75 16.725 23.142 16.3336 23.625 16.3336Z",
    fill: "#FF671D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserTag);
export default __webpack_public_path__ + "static/media/user-tag.8a317ffef19273f83c2657e99f682814.svg";
export { ForwardRef as ReactComponent };